import React, { Component } from 'react';
import { withRouter } from 'react-router';
import pathStateService from './PathStateService';
import { Button } from 'reactstrap';

class PathStateDeletePlain extends Component {
	constructor(props) {
		super(props);
		this.state = { users: [], loading: true };

		const { match } = this.props;
		this.id = match.params.id;
	}

	componentDidMount() {

	}

	handleClickOk = () => {
		const { history } = this.props;

		(async () => {
			await pathStateService.delete(this.id);
			history.push('/pathstates');
		})();
	}

	handleClickCancel = () => {
		const { history } = this.props;

		history.push('/pathstates');
	}

	render() {
		return (
			<div>
				<h2>Are you sure you want to delete path state ?</h2>

				<button onClick={this.handleClickOk}>Yes</button>
				<button onClick={this.handleClickCancel}>No</button>
			</div>
		);
	}
}
export const PathStateDelete = withRouter(PathStateDeletePlain);